export default __webpack_public_path__ + "static/media/Signup[1].ecb27400.svg";